export default "__VITE_ASSET__DWcTo6yj__"